export const isDentlabUser = (env: any) => {
  return env.VITE_APP_TITLE === "dentLAB" || env.VITE_APP_TITLE === "dentLAB-dev" || env.VITE_APP_TITLE === "dentLAB-dev_testing";
};

export const isDentconnectUser = (env: any) => {
  return env.VITE_APP_TITLE === "dentCONNECT" || env.VITE_APP_TITLE === "dentConnect-dev" || env.VITE_APP_TITLE === "dentConnect-dev_testing";
};

export const isDeveloper = (env: any, email?: any) => {
  return env.VITE_APP_TITLE === "dentLAB-dev" || env.VITE_APP_TITLE === "dentCONNECT-dev" || env.VITE_APP_TITLE === "dentLAB-dev_testing" || env.VITE_APP_TITLE === "dentConnect-dev_testing" || (email?.includes("support-") && email?.includes("@dentdesk.ch"));
};

// For Posthog feature flags, we do not want to identify support accounts so that they stay on the same version as the users
export const isPosthogDeveloper = (env: any, email?: any) => {
  return env.VITE_APP_TITLE === "dentLAB-dev" || env.VITE_APP_TITLE === "dentCONNECT-dev" || env.VITE_APP_TITLE === "dentLAB-dev_testing" || env.VITE_APP_TITLE === "dentConnect-dev_testing" ||
    (!email?.includes("support") && email?.includes("@dentdesk.ch"));
};

export const isUsingDevelopmentEnvironment = (env: any) => {
  return env.VITE_APP_TITLE === "dentLAB-dev" || env.VITE_APP_TITLE === "dentCONNECT-dev" || env.VITE_APP_TITLE === "dentLAB-dev_testing" || env.VITE_APP_TITLE === "dentConnect-dev_testing";
};